export enum ComboBoxType
{
    dropDown,
    dropDownList
}